import Head from "next/head";
import React from "react";
import Features from "../components/Business/B2Cstack/Features/Features";
import Heading from "../components/Business/B2Cstack/Heading/Heading";
import Navbar from "../components/Common/Navbar/Navbar";
import styles from "../styles/Home.module.scss";
import Hero from "../components/Business/B2Cstack/Hero/Hero";
import CoreFeature from "../components/Business/B2Cstack/CoreFeature/CoreFeature";
import Platform from "../components/Business/B2Cstack/Platform/Platform";
import TechnicalCapabilities from "../components/Business/B2Cstack/TechnicalCapabilities/TechnicalCapabilities";
import BusinessTool from "../components/Business/B2Cstack/BusinessTool/BusinessTool";

const business = () => {
  return (
    <>
      <Head>
        <title>B2C & D2C Stack | Socommerz</title>
        <meta name="title" content="B2C & D2C Stack | Socommerz" />
        <meta
          name="description"
          content="Maximize Your Business Growth By Reducing the Complexity of Commerce For Your Business Partners and Customers."
        />
        <meta name="keywords" content="b2b & d2c, d2c, business partners" />
        <meta name="robots" content="index,follow" />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.socommerz.com/b2b-stack/"
        />
        <meta property="og:title" content="B2C & D2C Stack | Socommerz" />
        <meta
          property="og:description"
          content="Maximize Your Business Growth By Reducing the Complexity of Commerce For Your Business Partners and Customers."
        />
        <link rel="canonical" href="https://www.socommerz.com/b2b-stack/" />
        <link
          rel="alternate"
          href="https://www.socommerz.com/b2b-stack/"
          hrefLang="en-in"
        />
        <meta
          property="twitter:url"
          content="https://www.socommerz.com/b2b-stack/"
        />
        <meta property="twitter:title" content="B2C & D2C Stack | Socommerz" />
        <meta
          property="twitter:description"
          content="Maximize Your Business Growth By Reducing the Complexity of Commerce For Your Business Partners and Customers."
        />
      </Head>
      <main className={styles["b2c-wrapper"]}>
        <Hero/>
        <CoreFeature/>
        <Platform/>
        <BusinessTool/>
        <TechnicalCapabilities/>
        {/* <Heading />
        <Features /> */}
      </main>
    </>
  );
};

export default business;
